// extracted by mini-css-extract-plugin
export default {"item":"style_item__5hZfS","deleteButton":"style_deleteButton__QGHZZ","logo":"style_logo__0E0W-","info":"style_info__2kuvM"};